if (!customElements.get('media-gallery')) {
  // NordLykke: inject media gallery + modal swipe styles once
  (function () {
    if (document.getElementById('nl-media-styles')) return;
    const nlStyle = document.createElement('style');
    nlStyle.id = 'nl-media-styles';
    nlStyle.textContent = `/* ==========================================================================
   NordLykke media customizations
   1. Desktop main-gallery prev/next navigation
   2. Mobile enlarged-modal swipe gallery
   3. Desktop lightbox image size cap
   Loaded from snippets/product-media-gallery.liquid (product pages only).
   ========================================================================== */

/* --- 1. Desktop main-gallery navigation ------------------------------------ */
.product__media-nav {
  display: none;
}

@media screen and (min-width: 750px) {
  media-gallery slider-component[id^='GalleryViewer'] {
    position: relative;
    display: block;
  }

  .product__media-nav {
    display: block;
    pointer-events: none;
  }

  .product__media-nav-button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 3;
    pointer-events: auto;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 4.2rem;
    height: 4.2rem;
    padding: 0;
    border: 0.1rem solid rgba(var(--color-foreground), 0.08);
    border-radius: 50%;
    background-color: rgba(var(--color-background), 0.82);
    color: rgb(var(--color-foreground));
    cursor: pointer;
    box-shadow: 0 0.2rem 0.8rem rgba(var(--color-foreground), 0.12);
    -webkit-backdrop-filter: blur(4px);
    backdrop-filter: blur(4px);
    transition: background-color 0.2s ease, opacity 0.2s ease;
  }

  .product__media-nav-button:hover {
    background-color: rgb(var(--color-background));
  }

  .product__media-nav-button:focus-visible {
    outline: 0.2rem solid rgb(var(--color-foreground));
    outline-offset: 0.2rem;
  }

  .product__media-nav-button svg {
    width: 2.2rem;
    height: 2.2rem;
  }

  .product__media-nav-button--prev {
    left: 1.4rem;
  }

  .product__media-nav-button--next {
    right: 1.4rem;
  }

  .product__media-nav-button[disabled] {
    opacity: 0;
    pointer-events: none;
  }
}

/* --- 2. Mobile enlarged-modal swipe gallery -------------------------------- */
.product-media-modal__nav {
  display: none;
}

@media screen and (max-width: 749px) {
  .product-media-modal--swipe .product-media-modal__content {
    display: flex !important;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    height: 100vh;
    max-height: 100vh;
    width: 100%;
    padding: 0;
    overflow-x: auto;
    overflow-y: hidden;
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  }

  .product-media-modal--swipe .product-media-modal__content::-webkit-scrollbar {
    display: none;
  }

  .product-media-modal--swipe .product-media-modal__content > * {
    display: block !important;
    flex: 0 0 100%;
    width: 100%;
    max-width: 100%;
    margin: 0;
    align-self: center;
    box-sizing: border-box;
    padding: 0 0.4rem;
    scroll-snap-align: center;
    scroll-snap-stop: always;
  }

  .product-media-modal--swipe .product-media-modal__content > img {
    height: auto;
    max-height: 90vh;
    object-fit: contain;
  }

  .product-media-modal--swipe .product-media-modal__content > .deferred-media,
  .product-media-modal--swipe .product-media-modal__content > product-model,
  .product-media-modal--swipe .product-media-modal__content > .product-media-modal__model {
    height: auto;
  }

  .product-media-modal--swipe .product-media-modal__nav {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 50%;
    transform: translateY(-50%);
    z-index: 3;
    width: 4rem;
    height: 4rem;
    padding: 0;
    border: 0.1rem solid rgba(var(--color-foreground), 0.08);
    border-radius: 50%;
    background-color: rgba(var(--color-background), 0.85);
    color: rgb(var(--color-foreground));
    cursor: pointer;
    box-shadow: 0 0.2rem 0.8rem rgba(var(--color-foreground), 0.18);
    transition: opacity 0.2s ease, background-color 0.2s ease;
  }

  .product-media-modal--swipe .product-media-modal__nav--prev {
    left: 1.2rem;
  }

  .product-media-modal--swipe .product-media-modal__nav--next {
    right: 1.2rem;
  }

  .product-media-modal--swipe .product-media-modal__nav[disabled] {
    opacity: 0;
    pointer-events: none;
  }

  .product-media-modal--swipe .product-media-modal__nav:focus-visible {
    outline: 0.2rem solid rgb(var(--color-foreground));
    outline-offset: 0.2rem;
  }
}

@media screen and (min-width: 750px) {
  .product-media-modal--swipe .product-media-modal__content > img,
  .product-media-modal--swipe .product-media-modal__content > * img {
    width: auto;
    max-width: 85vw;
    max-height: 85vh;
    margin: 0 auto;
    object-fit: contain;
  }

  .product-media-modal--swipe .product-media-modal__content > .deferred-media,
  .product-media-modal--swipe .product-media-modal__content > .media,
  .product-media-modal--swipe .product-media-modal__content > product-model {
    max-width: 85vw;
    max-height: 85vh;
    margin: 0 auto;
  }
}
`;
    document.head.appendChild(nlStyle);
  })();
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;
        this.prependMedia = this.dataset.disablePrepend != 'true';      
        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();

        // NordLykke: desktop main-gallery prev/next navigation (reuses setActiveMedia)
        this.buildGalleryNav();
      }

      buildGalleryNav() {
        if (!this.elements.viewer) return;
        if (!this.dataset.desktopLayout || !this.dataset.desktopLayout.includes('thumbnail')) return;
        if (this.galleryMediaItems().length < 2) return;
        if (this.elements.viewer.querySelector('.product__media-nav')) return;

        const nav = document.createElement('div');
        nav.className = 'product__media-nav quick-add-hidden small-hide';
        nav.innerHTML =
          '<button type="button" class="product__media-nav-button product__media-nav-button--prev" data-gallery-prev aria-label="Forrige bilde">' +
          '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false" width="22" height="22"><path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
          '<button type="button" class="product__media-nav-button product__media-nav-button--next" data-gallery-next aria-label="Neste bilde">' +
          '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false" width="22" height="22"><path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
        this.elements.viewer.appendChild(nav);

        this.galleryNav = nav;
        this.navPrevButton = nav.querySelector('[data-gallery-prev]');
        this.navNextButton = nav.querySelector('[data-gallery-next]');
        this.navPrevButton.addEventListener('click', () => this.navigateMedia(-1));
        this.navNextButton.addEventListener('click', () => this.navigateMedia(1));
        this.elements.viewer.addEventListener('keydown', this.onGalleryKeydown.bind(this));
        this.updateGalleryNav();
      }

      galleryMediaItems() {
        return Array.from(this.elements.viewer.querySelectorAll('.product__media-item[data-media-id]'));
      }

      navigateMedia(direction) {
        const items = this.galleryMediaItems();
        if (items.length < 2) return;
        let currentIndex = items.findIndex((item) => item.classList.contains('is-active'));
        if (currentIndex === -1) currentIndex = 0;
        const nextIndex = currentIndex + direction;
        if (nextIndex < 0 || nextIndex > items.length - 1) return;
        this.setActiveMedia(items[nextIndex].dataset.mediaId, false);
        this.updateGalleryNav();
      }

      updateGalleryNav() {
        if (!this.galleryNav) return;
        const items = this.galleryMediaItems();
        let currentIndex = items.findIndex((item) => item.classList.contains('is-active'));
        if (currentIndex === -1) currentIndex = 0;
        if (this.navPrevButton) this.navPrevButton.toggleAttribute('disabled', currentIndex <= 0);
        if (this.navNextButton) this.navNextButton.toggleAttribute('disabled', currentIndex >= items.length - 1);
      }

      onGalleryKeydown(event) {
        if (event.target.closest('iframe, video, model-viewer, .deferred-media')) return;
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.navigateMedia(1);
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.navigateMedia(-1);
        }
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend && this.prependMedia) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({behavior: 'smooth'});
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        
        if ( activeMedia.querySelector('.internal-video--playing video')) {
          activeMedia.querySelector('video').play();

        }
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        if (this.galleryNav) this.updateGalleryNav();
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
